import { useTranslation } from "react-i18next";
import "./languageDisplay.css";
import Cookies from "universal-cookie";
import GlobalAppContext from "../../../../../globals/GlobalAppContext";

const LanguageDisplay = () => {
    const { t, i18n } = useTranslation("settings");
    const cookies = new Cookies();
    const currentLanguage = cookies.get("language");
    const languageList = GlobalAppContext.supportedLanguages;

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        console.log(
            "Changed language to",
            GlobalAppContext.displayFullLanguageName(i18n.language),
        );
    };

    const onChange = (e) => {
        const selectedLanguage = e.target.value; // Get the value of the selected language
        changeLanguage(selectedLanguage); // Change language
        setLanguageCookie(selectedLanguage);
    };

    const setLanguageCookie = (language) => {
        document.cookie =
            "language=" +
            language +
            ";expires=" +
            new Date(
                new Date().getTime() + 60 * 60 * 5000000 * 24,
            ).toGMTString() +
            ";path=/";
    };

    let optionsArray = [];

    languageList.forEach((element) => {
        optionsArray.push(
            <option key={element} value={element}>
                {GlobalAppContext.displayFullLanguageName(element)}
            </option>,
        );
    });

    return (
        <>
            <h3>{t("languageSettings")}</h3>
            <select
                className="languageDisplaySelector"
                name="Language"
                value={currentLanguage ? currentLanguage : "en"}
                onChange={onChange}
            >
                {optionsArray}
            </select>
        </>
    );
};

export default LanguageDisplay;
